import { apiClient } from "@lib/axios";
import type {
  PromoteLayoutsResponse,
  PublishLayoutsResponse,
  PublishLayoutsTarget,
} from "./types";

// Admin-only backend routes (assets-deployment router); non-admin callers get
// a 403 from the backend regardless of the UI gating.
export const layoutsPublishApi = {
  publish: (
    options: { folderId?: string; target?: PublishLayoutsTarget } = {},
    signal?: AbortSignal,
  ) =>
    apiClient.post<
      PublishLayoutsResponse,
      { folderId?: string; target?: PublishLayoutsTarget }
    >(
      "/assets-deployment/publish-layouts",
      {
        ...(options.folderId ? { folderId: options.folderId } : {}),
        ...(options.target ? { target: options.target } : {}),
      },
      signal ? { signal } : undefined,
    ),
  // Copies the validated test pair over the production one (previous
  // production pair is archived server-side for rollback).
  promote: (signal?: AbortSignal) =>
    apiClient.post<PromoteLayoutsResponse, Record<string, never>>(
      "/assets-deployment/promote-layouts",
      {},
      signal ? { signal } : undefined,
    ),
};
